/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { InfoPopover } from "components/InfoPopover"
import XlsxDownload from "features/userParameters/XlsxDownload"
import XlsxUpload from "features/userParameters/XlsxUpload"

const XlsxHandling = () => {
  return (
    <fieldset className="form-group mb-3 p-3 border rounded">
      <legend className="d-flex align-items-center">
        Save or Load Your Plan
        <InfoPopover content="Save your current parameters as an .xlsx file or load previously saved parameters." />
      </legend>
      <div className="d-flex flex-wrap gap-3 mb-2">
        <div>
          <XlsxDownload />
        </div>
        <div>
          <XlsxUpload />
        </div>
      </div>
    </fieldset>
  )
}

export default XlsxHandling
